import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-full grid place-items-center px-6">
      <div className="card max-w-sm text-center">
        <h1 className="font-bold mb-2">Lost the beat?</h1>
        <p className="text-sm text-peak-muted mb-4">That page doesn't exist.</p>
        <Link to="/" className="btn-primary inline-block">Back to song requests</Link>
      </div>
    </div>
  )
}
